import { z } from "zod";

const AccountSchema = z.object({
  Id: z.string(),
  LegalEntityId: z.string(),
  Name: z.string(),
  Status: z.string(),
  StatusId: z.number(),
  CredStatusId: z.number(),
});

const BusinessUnitSchema = z.object({
  Id: z.string(),
  LegalEntityId: z.string(),
  Address: z.string().optional(),
  Name: z.string(),
  AccountNumber: z.string(),
  Number: z.string().optional(),
  Status: z.string(),
  StatusId: z.number(),
});

export const ScanDataAccountItemSchema = z.object({
  Id: z.string(),
  AccountId: z.string(),
  VendorId: z.number(),
  VendorName: z.string(),
  Account: AccountSchema,
  BusinessUnits: z.array(BusinessUnitSchema),
});

export type ScanDataAccountItemType = z.infer<typeof ScanDataAccountItemSchema>;
